import React from 'react';
import SelectWithAllToggle from '../common/SelectWithAllToggle';
import ProblemTypeTreeSelect from '../problem_type_tree_select';
import OWLocationAsyncTreeSelect from '../ow_location_async_tree_select/OWLocationAsyncTreeSelect';
import { LocationDropdownRecord } from '../name_component/location/LocationDropdownRecord';

const PROBLEM_TYPES_TC = 'ENTITY_REQUEST_SUPPLIER_PROBLEM_TYPES_AUTOCOMPLETE';
const LOCATIONS_TC = 'ENTITY_REQUEST_SUPPLIER_LOCATIONS_AUTOCOMPLETE';

interface SupplierCoverageFieldsProps {
	form: any;
	problemTypes: any;
	fetchProblemTypes: any;
	fetchMultipleProblemTypes: any;
	locations: any;
	fetchLocations: any;
	fetchMultipleLocations: any;
}

// Problem-type + location coverage with "Select All" toggles (wizard step 2 / Add Supplier modal).
const SupplierCoverageFields: React.FC<SupplierCoverageFieldsProps> = ({
	form,
	problemTypes,
	fetchProblemTypes,
	fetchMultipleProblemTypes,
	locations,
	fetchLocations,
	fetchMultipleLocations,
}) => {
	const fetchProblemTypesData = (
		searchText,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		fetchProblemTypes(
			{ name: searchText },
			targetCollectionName,
			pagination,
			sorting,
			filters,
			addToTargetCollection
		);

	const fetchLocationsData = (
		searchText,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		fetchLocations(
			{ name: searchText },
			targetCollectionName,
			pagination,
			sorting,
			filters,
			addToTargetCollection
		);

	const renderLocationRecord = (record) => <LocationDropdownRecord record={record} />;

	return (
		<>
			<SelectWithAllToggle
				label="Problem Types"
				name="problemTypeIds"
				allName="allProblemTypes"
				form={form}
				displaySelectAllWithLabel
				selectAllPlaceholder="Select All Problem Types"
			>
				<ProblemTypeTreeSelect
					mode="multiple"
					collapseSelectionForDisplay
					stateSlice={problemTypes}
					targetCollectionName={PROBLEM_TYPES_TC}
					fetchMultiple={fetchMultipleProblemTypes}
					fetchData={fetchProblemTypesData}
					additionalFilters={{}}
					sortBy={{ sort_by: 'name', order: 'ascend' }}
					placeholder="Select Problem Types"
				/>
			</SelectWithAllToggle>
			<SelectWithAllToggle
				label="Locations"
				name="locationIds"
				allName="allLocations"
				form={form}
				displaySelectAllWithLabel
				selectAllPlaceholder="Select All Locations"
			>
				<OWLocationAsyncTreeSelect
					mode="multiple"
					stateSlice={locations}
					targetCollectionName={LOCATIONS_TC}
					fetchMultiple={fetchMultipleLocations}
					fetchData={fetchLocationsData}
					emptyWhenDisabled={true}
					placeholder="Select Locations"
					renderRecord={renderLocationRecord}
				/>
			</SelectWithAllToggle>
		</>
	);
};

export default SupplierCoverageFields;
